import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { HashGenerator } from "../components/HashGenerator";
import { HgBreadcrumb } from "../components/HgBreadcrumb";
import { HgExplainer } from "../components/HgExplainer";

export function HashGeneratorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <HgBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.hg_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.hg_intro()}
          </p>
        </header>

        <HashGenerator />

        <HgExplainer
          howTo={m.hg_howto()}
          faqs={[
            { q: m.hg_faq1_q(), a: m.hg_faq1_a() },
            { q: m.hg_faq2_q(), a: m.hg_faq2_a() },
            { q: m.hg_faq3_q(), a: m.hg_faq3_a() },
            { q: m.hg_faq4_q(), a: m.hg_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
